module.exports = __webpack_public_path__ + "static/remit-879b3c279d3178d1ab3bfd3d91114442.jpg";